import React from 'react'
import Lottie, { EventListener } from 'react-lottie'
import { useWhiteLabel } from 'src/white-label'

export default function Rocket(props: any) {
  const { animationData: AnimationData } = useWhiteLabel()

  const defaultOptions = {
    loop: false,
    autoplay: false,
    animationData: AnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const listenerComplete: EventListener = {
    eventName: 'complete',
    callback: () => {
      props.onAnimEnd ? props.onAnimEnd() : console.log('element ended')
    },
  }
  const eventListeners = [listenerComplete]

  return (
    <div>
      <Lottie
        options={defaultOptions}
        speed={props.speed}
        height={props.height}
        width={props.width}
        isPaused={props.isPaused}
        isClickToPauseDisabled={true}
        eventListeners={eventListeners}
      />
    </div>
  )
}
